import React from 'react';
import { useLoadingStore } from '../../../stores/loadingStore';

export const GlobalProgressBar: React.FC = () => {
    const isLoading = useLoadingStore((state) => state.isLoading);

    if (!isLoading) return null;

    return (
        <div className="fixed top-0 left-0 right-0 z-[9999] h-1 bg-transparent">
            <div className="h-full bg-gradient-to-r from-blue-500 to-purple-600 shadow-lg animate-[loading_1.5s_ease-in-out_infinite] origin-left"></div>
        </div>
    );
}; 